module.exports = ng.material.dialog;